// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3Xdrs","author":"Table_author__3ux66","authorImage":"Table_authorImage__2Ab-7","unreadRow":"Table_unreadRow__t1Lam"};